<template>
  <div class="splash-screen">
      <div class="logo"></div>
      <img src="@/assets/logo-ana-2.png" alt="Logo da Ana">
  </div>
</template>

<script>
export default {
  mounted () {
     this.irParaHome();
  },

  methods: {
    irParaHome () {
      setTimeout(() => {
        this.$router.push('/home');
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped>
.splash-screen {
  background-image: url(../assets/splash.png);
  height: 100vh;
  width: 100vw;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .logo {
    background-image: url(../assets/logo.png);
    background-position: top center;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: -4px;
    width: 305px;
    height: 119px;
    border-radius: 28px;
  }

  img {
    height: 77px;
    width: 188px;
    filter: drop-shadow(0 3px 5px rgba(0,0,0,.9));
    animation: zoomIn 1s linear;
    position: absolute;
  }

  @keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

}
</style>
